import React, {useEffect} from "react";
import AddressPickerGP from "./AddressPickerGP";
import {useConsumerContext} from "../../context/ConsumerContext";
import {makeStyles} from "@material-ui/core/styles";
import {Step, StepButton, Stepper} from "@material-ui/core";
import PropertyRequirement from "./PropertyRequirement";
import PropertyDetails from "./PropertyDetails";
import OtherDetails from "./OtherDetails";
import Pets from "./Pets";
import ApplicationReview from "./ApplicationReview";
import UserDetails from "./UserDetails";
import WelcomePage from "./WelcomePage";
import AddrPicker from "./AddrPicker";


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: "#eaeef3"
    },
    button: {
        marginRight: theme.spacing(1),
    },
    completed: {
        display: 'inline-block',
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    grayBackground: {
        backgroundColor: "#eaeef3"
    },
    stepperMobile: {
        [theme.breakpoints.only('xs')]: {
            display: 'none',
            backgroundColor: "#eaeef3"
        }
    },
    stepperNonMobile: {
        [theme.breakpoints.up('sm')]: {
            display: 'block',
            backgroundColor: "#eaeef3"
        }
    }
}));

function getSteps() {
    return ['Property Requirement', 'Property Details', 'Other Details', 'Pets (Optional)', 'Application Review', 'Contact Info'];
}
const useGooglePlaces = process.env.REACT_APP_USE_GOOGLE_PLACES;

export default function WizardFlow() {
    const {consumerData} = useConsumerContext();
    const classes = useStyles();
    const steps = getSteps();

    function TopBar() {
        return (
            <div className={classes.stepperMobile}>
                <Stepper nonLinear activeStep={consumerData.wizardStep} className={classes.grayBackground}>
                    {steps.map((label, index) => (
                        <Step key={label}>
                            <StepButton>
                                {label}
                            </StepButton>
                        </Step>
                    ))}
                </Stepper>
            </div>
        );
    }


    if (consumerData.wizardStep === -2) return (
        <>
            <WelcomePage/>
        </>
    )
    else if (consumerData.wizardStep === -1) return (
        <>
            <div>
                {useGooglePlaces === true || useGooglePlaces === 'true' && <AddressPickerGP/>}
                {useGooglePlaces !== true && useGooglePlaces !== 'true' && <AddrPicker/>}
            </div>
        </>
    )
    else if (consumerData.wizardStep === 0) return (
        <>
            <TopBar/>
            <PropertyRequirement/>
        </>
    )
    else if (consumerData.wizardStep === 1) return (
        <>
            <TopBar/>
            <PropertyDetails/>
        </>
    )
    else if (consumerData.wizardStep === 2) return (
        <>
            <TopBar/>
            <OtherDetails/>
        </>
    )
    else if (consumerData.wizardStep === 3) return (
        <>
            <TopBar/>
            <Pets/>
        </>
    )
    else if (consumerData.wizardStep === 4) return (
        <>
            <TopBar/>
            <ApplicationReview/>
        </>
    )
    else if (consumerData.wizardStep === 5) return (
        <>
            <TopBar/>
            <UserDetails/>
        </>
    )
    else return <WelcomePage/>
}
